import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter} from "../../../utils/formatters";
import {list} from "../../../utils/array";
import Confirm, {smallDeleteProps} from "../../form/Confirm";
import {deleteComponent} from "../../../utils/components";

export default class DeliveryList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        props.filter = list(props.filter);
        if (this.props.componentEditor === "MainMenuDelivery") {
            props.filter.push({field: "recipient", value: this.props.user.id});
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "DeliveryList"}
                {...props}
                view={["state"]}
                columns={{
                    ...(this.props.componentEditor === "MainMenuDelivery" ? {
                        "actions": {
                            header: ' ',
                            width: 'cell-button',
                            renderer: (v, rowData) => (parseInt(rowData.state || "0") === 0 || parseInt(rowData.state || "0") === 3) && <Confirm
                                {...smallDeleteProps}
                                onAccept={async () => {
                                    await deleteComponent(props.componentConfig.componentname, {[componentConfig.idfield]: rowData[componentConfig.idfield]});
                                    this.list && this.list.refresh();
                                }}
                            />
                        }
                    } : {}),
                    "id": {header: 'ID', width: 1, sortable, filterable},
                    "sendername": {header: 'Kitől', width: 2, sortable, filterable},
                    "recipient.name": {header: 'Kinek', width: 2, sortable, filterable},
                    "delivery_description": {header: 'Leírás', width: 5, sortable, filterable},
                    "reception_date": {header: 'Átvétel dátuma', width: 2, sortable, filterable}
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={this.props.componentEditor !== "MainMenuDelivery" ? selection : null}
                onSelectionChange={(selection) => {
                    if (this.props.componentEditor !== "MainMenuDelivery") {
                        this.props.loadForm(selection.value);
                    }
                }}
            />
        );
    }
}
